import { TransactionStatus } from './paystack';

export interface PaymentServiceApiResponse<T> {
  code: string;
  statusCode: string;
  message: string;
  data: T;
}

export interface BankAccount {
  bank: string;
  processed: boolean;
  accountNumber: string;
}

export class PaymentInstructionModel {
  accessCode: string;
  accounts: BankAccount[];
  checkoutUrl: string;
  paymentAmount: number;
  paymentFee: number;
  paymentMethod: PaymmentOptionModel;
  paymentOptions: PaymmentOptionModel[];
  reference: string;
  requestNumber: string;
  transactionAmount: number;
  authToken?: string;
  walletBalance?: number;
  currency: string;
  callBackUrl?: string;

  constructor(data: PaymentInstructionModel) {
    this.accessCode = data.accessCode;
    this.accounts = data.accounts;
    this.checkoutUrl = data.checkoutUrl;
    this.paymentAmount = data.paymentAmount;
    this.paymentFee = data.paymentFee;
    this.reference = data.reference;
    this.requestNumber = data.requestNumber;
    this.transactionAmount = data.transactionAmount;
    this.authToken = data.authToken;
    this.walletBalance = data.walletBalance;
    this.currency = data.currency ?? 'NGN';
    this.callBackUrl = data.callBackUrl;
    this.paymentMethod = new PaymmentOptionModel(
      data.paymentMethod as unknown as string
    );

    this.paymentOptions = data.paymentOptions.map(
      option => new PaymmentOptionModel(option as unknown as string)
    );
  }
}

interface Wallet {
  accounts: Account[];
  balance: number;
}

interface Account {
  name: string;
  number: string;
  bank: string;
  amount: number;
}

export enum PaymentOptionsEnum {
  card = 'card',
  bank_transfer = 'bank_transfer',
  ussd = 'ussd',
  transfer = 'transfer',
  wallet = 'wallet',
  // loyalty = 'loyalty',
}

export class PaymmentOptionModel {
  prettyName: string;
  icon: string;
  constructor(public name: string) {
    this.name = name;
    switch (name) {
      case PaymentOptionsEnum.card:
        this.prettyName = 'Card';
        this.icon = 'card-icon';
        break;
      case PaymentOptionsEnum.bank_transfer:
        this.prettyName = 'Bank Transfer';
        this.icon = 'bank-icon';
        break;
      case PaymentOptionsEnum.ussd:
        this.prettyName = 'USSD';
        this.icon = 'hashtag-icon';
        break;
      case PaymentOptionsEnum.transfer:
        this.prettyName = 'Transfer';
        this.icon = 'bank-icon';
        break;
      case PaymentOptionsEnum.wallet:
        this.prettyName = 'Wallet';
        this.icon = 'wallet-icon';
        break;
      // case PaymentOptionsEnum.loyalty:
      //   this.prettyName = 'Loyalty';
      //   this.icon = 'loyalty-icon';
      //   break;
      default:
        this.prettyName = name;
        this.icon = name;
    }
  }
}

export interface VerifyHandshakeResponseModel {
  access: string;
}

export interface PaymentStatus {
  reference: string;
  amount: number;
  status: TransactionStatus;
  orderId: string;
  channel: string;
  method: string;
  date: string;
}

export interface PayWithWalletRequestModel {
  reference: string;
  authToken: string;
}
